import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IChecklistAfterSeason } from './interfaces';

export const getChecklistAfterSeasonList = (data: IDynamicTableParams) => {
  return instance()
    .post<IChecklistAfterSeason[]>('/checkList/after/season/list', data)
    .then((response) => response.data);
};

export const getChecklistAfterSeasonListAll = () => {
  return instance()
    .post<IChecklistAfterSeason[]>('/checkList/after/season/listAll')
    .then((response) => response.data);
};

export const getChecklistAfterSeasonListAllNotDeleted = () => {
  return instance()
    .post<IChecklistAfterSeason[]>('/checkList/after/season/listAllNotDeleted')
    .then((response) => response.data);
};

export const getChecklistAfterSeasonAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/checkList/after/season/availableColumns')
    .then((response) => response.data);
};

export const getChecklistAfterSeasonAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/checkList/after/season/availableGroupColumns')
    .then((response) => response.data);
};

export const loadChecklistAfterSeason = (seasonId: number) => {
  return instance()
    .get<IChecklistAfterSeason>(`/checkList/after/season/load/${seasonId}`)
    .then((response) => response.data);
};

export const createChecklistAfterSeason = (season: IChecklistAfterSeason) => {
  return instance()
    .post<IChecklistAfterSeason>(`/checkList/after/season/save`, season)
    .then((response) => response.data);
};

export const updateChecklistAfterSeason = (season: IChecklistAfterSeason) => {
  return instance()
    .post<IChecklistAfterSeason>(`/checkList/after/season/${season.seasonId}/update`, season)
    .then((response) => response.data);
};

export const archiveChecklistAfterSeason = (seasonId: number) => {
  return instance()
    .post(`/checkList/after/season/archive`, { seasonId })
    .then((response) => response.data);
};

export const recoverChecklistAfterSeason = (seasonId: number) => {
  return instance()
    .post(`/checkList/after/season/recover`, { seasonId })
    .then((response) => response.data);
};
